import Head from 'next/head';

export const HeadFavicon = () => (
  <Head>
    <link href="/kaimono/images/favicon-256x256.webp" rel="apple-touch-icon" sizes="180x180" />
    <link href="/kaimono/images/favicon-256x256.webp" rel="icon" sizes="32x32" type="image/png" />
    <link href="/kaimono/favicon.ico" rel="icon" sizes="16x16" type="image/png" />
    <meta content="#ffffff" name="theme-color" />
  </Head>
);
